<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-md-8 col-lg-6">
      <div class="card card-v2 mt-5">
        <div class="card-body text-center py-5">
          <!-- Icon -->
          <div class="mb-4">
            <div class="access-denied-icon">
              <lucide-icon name="lock"></lucide-icon>
            </div>
          </div>

          <!-- Title -->
          <h2 class="mb-3 font-semibold text-primary">
            {{ 'access_denied.title' | translate }}
          </h2>

          <!-- Description -->
          <p class="text-muted mb-4 max-w-400 mx-auto">
            {{ 'access_denied.description' | translate }}
          </p>

          <!-- Permission Info (if available) -->
          @if (requiredPermission) {
            <div class="alert alert-light mb-4" role="alert">
              <small class="text-muted">
                {{ 'access_denied.required_permission' | translate }}:
                <strong>{{ requiredPermission }}</strong>
              </small>
            </div>
          }

          <!-- Actions -->
          <div class="d-flex justify-content-center gap-3">
            <hc-button variant="secondary" leftIcon="arrow-left" (clicked)="goBack()">
              {{ 'access_denied.go_back' | translate }}
            </hc-button>
            <hc-button variant="primary" leftIcon="layout-dashboard" (clicked)="goToDashboard()">
              {{ 'access_denied.go_to_dashboard' | translate }}
            </hc-button>
          </div>

          <!-- Contact Admin -->
          <p class="text-muted small mt-4 mb-0">
            {{ 'access_denied.contact_admin' | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
